import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M18 6h4v11h-4zM7 19h10V4H7v15zM9 6h6v11H9V6zM2 6h4v11H2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 6h6v11H9z",
  opacity: ".3"
})), 'ViewCarouselTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewCarouselTwoTone.js
// module id = 7079
// module chunks = 2